
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.923 11.431A6 6 0 012.64 5.301a.96.96 0 00.034.489l.179.538a1 1 0 00.394.516l.414.276.064.043a.409.409 0 00.516-.63l-.187-.186a.546.546 0 01.31-.927l.963-.138A1 1 0 005.7 5.15l.78-.467a1 1 0 00.342-.343l.41-.683a.848.848 0 01.46-.369l.192-.064a.442.442 0 00-.067-.855l-.677-.113a1 1 0 01-.357-.132 5.995 5.995 0 016.227 2.573l-.809.269a1 1 0 01-.48.038l-.784-.131a.869.869 0 01-.58-.375.868.868 0 00-.722-.387h-.52a1 1 0 00-.708.293l-.053.054a1 1 0 00-.283.848l.083.582a1 1 0 00.596.777l.807.346a1 1 0 00.636.051l.237-.06a.86.86 0 011.07.836v.236c0 .156.035.309.105.447l.36.722.362.723a1 1 0 01.105.447v.466a.556.556 0 00.49.552zM15 8A7 7 0 111 8a7 7 0 0114 0zM8.67 9.611a.522.522 0 00-.513-.625.523.523 0 01-.448-.253l-.257-.428a1 1 0 00-.857-.485H5.85a.52.52 0 01-.466-.288.52.52 0 00-.833-.135l-.19.19-.173.173a1 1 0 00-.293.707v.05a1 1 0 00.106.447l.162.325c.125.25.36.43.634.484a.91.91 0 01.731.892v1.395a1 1 0 00.072.371l.326.816a.398.398 0 00.768-.148v-.304c0-.195.092-.378.248-.495l.38-.285a.766.766 0 00.306-.612c0-.203.08-.398.224-.541l.541-.542a.781.781 0 00.214-.4l.062-.309z"}})])
          )
        }
      }
    